import { useState } from 'react'
import { IconButton, InputAdornment } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

import AutoFillAwareTextInput from '../AutofillInput/AutoFillAwareTextInput'

const PasswordInput = ({ InputProps, ...props }) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <AutoFillAwareTextInput
      wrapperClassName="password-input"
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => setShowPassword((prev) => !prev)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  )
}

export default PasswordInput
